app.views.incomeExpenditureForm = app.views.base.extend({
  sfsTriggerFigures: new Array(),
  childEvents: {
    'click [data-income-expenditure-section]': 'toggleIncomeExpenditureSection',
    'keypress [data-income-expenditure-section]': 'toggleIncomeExpenditureSection',
    'click [data-confirm-iande]': 'submitIandEForm',
    'blur [data-input]': 'checkHomeFields',
    'blur [data-field-value]': 'calculateSectionTotal',
    'change [data-field-frequency]': 'calculateSectionTotal',
    'click [data-add-benefit]': 'showSelectedBenefitSelector',
    'change [data-field-benefits-list]': 'showSelectedBenefit',
    'click [data-remove-benefit]': 'hideBenefitField',
    'click [data-field-benefit-checkbox]': 'calculateSectionTotal',
    'click [data-dualfueltoggle]': 'toggleDualFuelOption',
    'blur [data-field-arrears-value]': 'validateArrearsValues',
    'click [data-add-non-priority-bill]': 'showNonPriorityBillSelector',
    'change [data-non-priority-bill-list]': 'addSelectedNonPriorityBill',
    'click [data-remove-non-priority-bill]': 'removeNonPriorityBillField',
    'blur [data-non-priority-bill-list]': 'addSelectedNonPriorityBill',
    'click [data-field-exclude-savings-checkbox]': 'calculateSectionTotal'
  },
  attr: {
    arrowToggle: 'data-arrow-icon',
    selectDIFrequency: 'data-select-disposable-frequency',
    DIFrequency: 'data-disposable-frequency',
    DIValue: 'data-disposable-value',
    confirmIandE: 'data-confirm-iande',
    sectionCode: 'data-section-code',
    sectionTotal: 'data-section-total',
    sfsInformation: 'data-sfs-information',
    fieldValue: 'data-field-value',
    fieldFrequency: 'data-field-frequency',
    fieldBenefitCheckbox: 'data-field-benefit-checkbox',
    benefit: 'data-benefit',
    benefitOptionCode: 'data-benefit-option-code',
    benefitsList: 'data-field-benefits-list',
    benefitFieldValue: 'data-benefit-field-value',
    removeBenefitFieldCode: 'data-remove-benefit-code',
    utilityField: 'data-utility-field',
    fieldArrears: 'data-field-arrears',
    fieldArrearsValue: 'data-field-arrears-value',
    debtAdvice: 'data-debt-advice',
    currencyAmount: 'data-currency',
    nonPriorityBillList: 'data-non-priority-bill-list',
    nonPriorityBillContent: 'data-non-priorty-bill-content',
    nonPriorityBillTemplate: 'data-template-non-priorty-bill',
    incomeSection: 'data-income-sections',
    expenditureSection: 'data-expenditure-sections',
    excludeSavingsCheckbox: 'data-field-exclude-savings-checkbox',
    benefitListSelection: 'data-benefits-list-section',
    benefitFields: 'data-benefit-fields',
    benefitAddButton: 'data-add-benefit',
    nonPriorityBillListSection: 'data-non-priority-bill-list-section',
    nonPriorityBillAddButton: 'data-add-non-priority-bill'
  },
  classes: {
    section: 'section',
    sectionHeading: 'section-heading',
    sectionContent: 'section-content',
    sectionWarning: 'section-warning',
    arrowUp: 'fa-chevron-up',
    arrowDown: 'fa-chevron-down',
    inputValidationError: 'input-validation-error',
    disabled: 'disabled',
    sfsWarning: 'sfs-warning',
    inputError: 'input-validation-error',
    fieldError: 'field-validation-error',
    fieldValid: 'field-validation-valid'
  },
  ids: {
    pageSpinner: 'PageSpinner',
    iandeFrom: 'IncomeExpenditureForm',
    numberOfAdults: 'HouseHold_NumberOfAdults',
    numberOfChildren16to18: 'HouseHold_NumberOfChildren16To18',
    numberOfChildrenUnder16: 'HouseHold_NumberOfChildrenUnder16'
  },
  contants: {
    dualFuelCode: 'DUAL_FUEL',
    gasCode: 'GAS',
    electricityCode: 'ELECTRICITY',
    nonPriorityIndex: '0'
  },
  settings: {
    pounds: {
      internationalCode: 'en-GB',
      style: 'currency',
      currencyCode: 'GBP'
    },
    slideSpeed: 200
  },
  init: function init(sfsFigures) {
    var _this = this;
    this.highlightValiadtionErrors();
    this.sfsTriggerFigures = sfsFigures;
    this.contants.nonPriorityIndex = $('[' + this.attr.nonPriorityBillContent + ']').find('li').length.toString();
    $('[' + this.attr.nonPriorityBillList + ']').on('select2:close', function (e) {
      $('[' + _this.attr.nonPriorityBillList + ']').val(null).trigger('change');
    });
    $('[data-site-navigation] a').on('click', function (e) {
      if ($(this).attr('target') != '_blank') {
        e.preventDefault();
        _this.openIandESaveWarningModal(this);
      }
    });
    $('[data-payment-amount]').each(function () {
      $(this).rules("add", {
        maxlength: 20,
        messages: {
          maxlength: "Exceeds maximum character limit."
        }
      });
    });
  },
  openIandESaveWarningModal: function openIandESaveWarningModal(element) {
    var destinationUrl = $(element).attr('href');
    var modalUrl = window.location.origin + "/income-expenditure-save-warning?destination=" + destinationUrl;
    app.helpers.openModal(modalUrl, "ajax");
  },
  toggleIncomeExpenditureSection: function toggleIncomeExpenditureSection(e) {
    _this = this;
    if (e.key == 'Enter' || e.keyCode == '32' || e.keyCode == undefined) {
      if ($(e.currentTarget).parent().find('.' + this.classes.sectionContent).is(':visible')) {
        $(e.currentTarget).parent().find('.' + this.classes.sectionContent).slideUp(this.settings.slideSpeed);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').addClass(this.classes.arrowDown);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').removeClass(this.classes.arrowUp);
      } else {
        $('.section-content').each(function () {
          if ($(this).is(':visible')) {
            $(this).slideUp(_this.settings.slideSpeed);
            $(this).parent().find('[' + _this.attr.arrowToggle + ']').addClass(_this.classes.arrowDown);
            $(this).parent().find('[' + _this.attr.arrowToggle + ']').removeClass(_this.classes.arrowUp);
          }
        });
        $(e.currentTarget).parent().find('.' + this.classes.sectionContent).slideDown(this.settings.slideSpeed, function () {
          $("html, body").animate({
            scrollTop: $(e.currentTarget).offset().top - 200
          }, _this.settings.slideSpeed);
        });
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').removeClass(this.classes.arrowDown);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').addClass(this.classes.arrowUp);
      }
    }
  },
  submitIandEForm: function submitIandEForm(e) {
    e.preventDefault();
    $('#' + this.ids.pageSpinner).show();
    this.highlightValiadtionErrors();
    var isValid = true;
    if ($("." + this.classes.inputValidationError).length) {
      isValid = false;
      $('#' + this.ids.pageSpinner).hide();
    }
    if (isValid) {
      var event = jQuery.Event("submit");
      $('#' + this.ids.iandeFrom).trigger(event);
      if (event.isDefaultPrevented()) {
        $('#' + this.ids.pageSpinner).hide();
      }
    }
  },
  highlightValiadtionErrors: function highlightValiadtionErrors() {
    this.validateArrearsValues();
    var _this = this;
    $('.' + this.classes.section).find('.' + this.classes.sectionHeading).removeClass(this.classes.sectionWarning);
    if ($("." + this.classes.inputValidationError).length) {
      $('[' + this.attr.confirmIandE + ']').addClass(this.classes.disabled);
      $('[' + this.attr.confirmIandE + ']').attr(this.classes.disabled, true);
      $.each($("." + this.classes.inputValidationError), function (i, item) {
        if (!$(item).closest('.' + _this.classes.section).find('.' + _this.classes.sectionHeading).hasClass(_this.classes.sectionWarning)) {
          $(item).closest('.' + _this.classes.section).find('.' + _this.classes.sectionHeading).addClass(_this.classes.sectionWarning);
        }
      });
    } else {
      $('[' + this.attr.confirmIandE + ']').removeClass(this.classes.disabled);
      $('[' + this.attr.confirmIandE + ']').removeAttr(this.classes.disabled);
    }
  },
  highlightSfsTriggeredSections: function highlightSfsTriggeredSections(e) {
    var _this = this;
    var numberOfAdults = $('#' + this.ids.numberOfAdults).val();
    var numberOfChildren16to18 = $('#' + this.ids.numberOfChildren16to18).val();
    var numberOfChildrenUnder16 = $('#' + this.ids.numberOfChildrenUnder16).val();
    $(this.sfsTriggerFigures).each(function () {
      if ($('[ ' + _this.attr.sectionCode + ' ="' + this.triggerType + '"]').length) {
        var section = $('[ ' + _this.attr.sectionCode + ' ="' + this.triggerType + '"]');
        var sectionCode = $(section).attr(_this.attr.sectionCode);
        var sectionValue = $(section).find('[' + _this.attr.sectionTotal + ']').html();
        var decimalSectionValue = Number(sectionValue.replace(/[^0-9.-]+/g, ""));
        var sectionGuidlineTotal = numberOfAdults > 1 ? this.adultTriggerValue + this.additionalAdultTriggerValue * (numberOfAdults - 1) : this.adultTriggerValue;
        sectionGuidlineTotal += numberOfChildren16to18 * this.children16To18TriggerValue;
        sectionGuidlineTotal += numberOfChildrenUnder16 * this.childrenUnder16TriggerValue;

        //check if the lands within a 10% threshold
        highThreshold = sectionGuidlineTotal + sectionGuidlineTotal * 0.1;
        lowThreshold = sectionGuidlineTotal - sectionGuidlineTotal * 0.1;
        if (decimalSectionValue > 0 && (decimalSectionValue > highThreshold || decimalSectionValue < lowThreshold)) {
          section.addClass(_this.classes.sfsWarning);
        } else {
          section.removeClass(_this.classes.sfsWarning);
        }
      }
    });
    if ($('.' + this.classes.sfsWarning).length) {
      $('[' + this.attr.sfsInformation + ']').show();
    } else {
      $('[' + this.attr.sfsInformation + ']').hide();
    }
  },
  checkHomeFields: function checkHomeFields(e) {
    this.removeNegatives(e);
    this.highlightValiadtionErrors();
    this.highlightSfsTriggeredSections();
  },
  removeNegatives: function removeNegatives(e) {
    if ($(e.currentTarget).val() < 0) {
      $(e.currentTarget).val(Math.abs($(e.currentTarget).val()));
      $(e.currentTarget).blur();
    }
  },
  calculateSectionTotal: function calculateSectionTotal(e) {
    var _this = this;
    this.highlightValiadtionErrors();
    var poundFormatting = new Intl.NumberFormat(this.settings.pounds.internationalCode, {
      style: _this.settings.pounds.style,
      currency: _this.settings.pounds.currencyCode
    });
    var sectionTotal = 0;
    var fields = $(e.currentTarget).closest('.' + this.classes.sectionContent).find('li');
    $(fields).each(function () {
      var fieldValue = $(this).find('[' + _this.attr.fieldValue + ']').val();
      var fieldFrequency = $(this).find('[' + _this.attr.fieldFrequency + ']').val();
      var hasBenefitCheckbox = $(this).find('[' + _this.attr.fieldBenefitCheckbox + ']').length;
      var benefitCheckboxChecked = $(this).find('[' + _this.attr.fieldBenefitCheckbox + ']').is(':checked');
      var hasSavingsCheckbox = $(this).find('[' + _this.attr.excludeSavingsCheckbox + ']').length;
      var savingsCheckboxChecked = $(this).find('[' + _this.attr.excludeSavingsCheckbox + ']').is(':checked');
      var decimalFieldValue = Number(fieldValue.replace(/[^0-9.-]+/g, ""));
      if (hasBenefitCheckbox && !benefitCheckboxChecked) {
        return true;
      }
      if (hasSavingsCheckbox && savingsCheckboxChecked) {
        return true;
      }
      switch (fieldFrequency) {
        case "MONTHLY":
          {
            sectionTotal += decimalFieldValue;
            break;
          }
        case "WEEKLY":
          {
            sectionTotal += _this._calculateMonthlyValue(decimalFieldValue, 52);
            break;
          }
        case "EVERY_2_WEEKS":
          {
            sectionTotal += _this._calculateMonthlyValue(decimalFieldValue, 26);
            break;
          }
        case "EVERY_4_WEEKS":
          {
            sectionTotal += _this._calculateMonthlyValue(decimalFieldValue, 13);
            break;
          }
        case "QUARTERLY":
          {
            sectionTotal += _this._calculateMonthlyValue(decimalFieldValue, 4);
            break;
          }
        case "ANNUALLY":
          {
            sectionTotal += _this._calculateMonthlyValue(decimalFieldValue, 1);
            break;
          }
        default:
          {
            sectionTotal += decimalFieldValue;
            break;
          }
      }
    });
    var displayValue = poundFormatting.format(sectionTotal);
    $(e.currentTarget).parents('.' + this.classes.sectionContent).prev('.' + this.classes.sectionHeading).find('[' + this.attr.sectionTotal + ']').html(displayValue);
    this.highlightSfsTriggeredSections();
    this._calculateSavings();
  },
  _calculateMonthlyValue: function _calculateMonthlyValue(fieldValue, multiplierValue) {
    var yearlyValue = Math.ceil(fieldValue * 100 * multiplierValue);
    var value = Math.floor(yearlyValue / 12) / 100;
    return value;
  },
  showSelectedBenefitSelector: function showSelectedBenefitSelector(e) {
    e.preventDefault();
    $('[' + this.attr.benefitAddButton + ']').hide();
    $('[' + this.attr.benefitsList + ']').val('');
    $('[' + this.attr.benefitsList + ']').select2({
      placeholder: "Select",
      allowClear: true
    });
    $('[' + this.attr.benefitListSelection + ']').slideDown(200);
  },
  showSelectedBenefit: function showSelectedBenefit(e) {
    var fieldCode = $(e.currentTarget).val();
    var benefit = $('[' + this.attr.benefit + '=' + fieldCode + ']');
    $('[' + this.attr.benefitFields + ']').append($(benefit));
    $('[' + this.attr.benefit + '=' + fieldCode + ']').slideDown(500);
    $('[' + this.attr.benefitOptionCode + '="' + fieldCode + '"]').attr('disabled', 'disabled');
    $('[' + this.attr.benefitsList + ']').val('');
    $('[' + this.attr.benefitsList + ']').select2();
    $('[' + this.attr.benefitListSelection + ']').hide();
    $('[' + this.attr.benefitAddButton + ']').show();
  },
  hideBenefitField: function hideBenefitField(e) {
    e.preventDefault();
    var fieldCode = $(e.currentTarget).attr(this.attr.removeBenefitFieldCode);
    $('[' + this.attr.benefitFieldValue + '=' + fieldCode + ']').val('');
    $('[' + this.attr.benefitFieldValue + '=' + fieldCode + ']').valid();
    $('[' + this.attr.benefitOptionCode + '="' + fieldCode + '"]').removeAttr('disabled');
    $('[' + this.attr.benefit + '="' + fieldCode + '"]').hide();
    $('[' + this.attr.benefitsList + ']').val('');
    $('[' + this.attr.benefitsList + ']').select2();
    this.calculateSectionTotal(e);
  },
  toggleDualFuelOption: function toggleDualFuelOption(e) {
    var isDualFuel = $(e.currentTarget).val() == 'true';
    if (isDualFuel) {
      $('[' + this.attr.utilityField + '="' + this.contants.dualFuelCode + '"]').slideDown(500);
      $('[' + this.attr.utilityField + '="' + this.contants.electricityCode + '"]').find('[' + this.attr.fieldValue + ']').val('');
      $('[' + this.attr.utilityField + '="' + this.contants.electricityCode + '"]').hide();
      $('[' + this.attr.utilityField + '="' + this.contants.gasCode + '"]').find('[' + this.attr.fieldValue + ']').val('');
      $('[' + this.attr.utilityField + '="' + this.contants.gasCode + '"]').hide();
    } else {
      $('[' + this.attr.utilityField + '="' + this.contants.dualFuelCode + '"]').hide();
      $('[' + this.attr.utilityField + '="' + this.contants.dualFuelCode + '"]').find('[' + this.attr.fieldValue + ']').val('');
      $('[' + this.attr.utilityField + '="' + this.contants.electricityCode + '"]').slideDown(500);
      $('[' + this.attr.utilityField + '="' + this.contants.gasCode + '"]').slideDown(500);
    }
  },
  validateArrearsValues: function validateArrearsValues() {
    var _this = this;
    var arrears = $('[' + this.attr.fieldArrears + ']');
    $('[' + _this.attr.debtAdvice + ']').hide();
    arrears.each(function () {
      var arrearsvalue = $(this).find('[' + _this.attr.fieldArrearsValue + ']').val();
      var decimalArrearsValue = Number(arrearsvalue.replace(/[^0-9.-]+/g, ""));
      var fieldCode = $(this).find('[' + _this.attr.fieldArrearsValue + ']').attr(_this.attr.fieldArrearsValue);
      var input = $(this).find('[' + _this.attr.fieldValue + '="' + fieldCode + '"]');
      var inputValue = $(input).val();
      var decimalInputValue = Number(inputValue.replace(/[^0-9.-]+/g, ""));
      if (decimalArrearsValue > 0) {
        //Checks more than £ symbol in field
        if (inputValue.length <= 1) {
          input.addClass(_this.classes.inputValidationError);
          input.next('.' + _this.classes.fieldValid).html('<span>Please enter a value, even "0"</span>');
          input.next('.' + _this.classes.fieldValid).addClass(_this.classes.fieldError);
          input.next('.' + _this.classes.fieldValid).removeClass(_this.classes.fieldValid);
        }
      }
      if (decimalArrearsValue > 0 || decimalInputValue > 0) {
        $('[' + _this.attr.debtAdvice + ']').show();
      }
    });
  },
  showNonPriorityBillSelector: function showNonPriorityBillSelector(e) {
    e.preventDefault();
    $('[' + this.attr.nonPriorityBillAddButton + ']').hide();
    $('[' + this.attr.nonPriorityBillList + ']').val('');
    $('[' + this.attr.nonPriorityBillList + ']').select2({
      placeholder: "Select",
      allowClear: true
    });
    $('[' + this.attr.nonPriorityBillListSection + ']').slideDown(200);
  },
  addSelectedNonPriorityBill: function addSelectedNonPriorityBill(e) {
    var _this = this;
    var numberOfFieldsNonPriorityBills = $('[' + this.attr.nonPriorityBillContent + ']').find('li').length;
    var index = this.contants.nonPriorityIndex;
    var fieldCode = $(e.currentTarget).val();
    $('[' + this.attr.nonPriorityBillListSection + ']').hide();
    $('[' + this.attr.nonPriorityBillAddButton + ']').show();
    if (fieldCode.length) {
      var fieldLabel = $('[' + this.attr.nonPriorityBillList + '] option:selected').text();
      var template = $('[' + this.attr.nonPriorityBillTemplate + ']').html();
      template = template.replaceAll("#index#", index);
      template = template.replaceAll("#label#", fieldLabel);
      template = template.replaceAll("#fieldCode#", fieldCode);
      $('[' + this.attr.nonPriorityBillContent + ']').append('<li data-test="Field' + fieldCode + '">' + template + '</li>');
      this._initNonPriorityCurrencyFormat();
      this.contants.nonPriorityIndex = Number(index) + 1;
      $('[' + this.attr.nonPriorityBillContent + ']').find('li').last().find('[' + this.attr.fieldFrequency + ']').select2();
      $('[' + this.attr.nonPriorityBillContent + ']').find('li').last().find('[' + _this.attr.fieldArrearsValue + ']').on('blur', function () {
        _this.validateArrearsValues();
      });
      $.validator.unobtrusive.parse('#IncomeExpenditureForm');
      $('[' + this.attr.nonPriorityBillContent + '] [data-payment-amount]').each(function () {
        $(this).rules("add", {
          maxlength: 20,
          messages: {
            maxlength: "Exceeds maximum character limit."
          }
        });
      });
    }
  },
  removeNonPriorityBillField: function removeNonPriorityBillField(e) {
    e.preventDefault();
    $(e.currentTarget).parents('li').remove();
    this._reIndexNonPriorityBills();
    this.calculateSectionTotal(e);
  },
  _initNonPriorityCurrencyFormat: function _initNonPriorityCurrencyFormat() {
    $('[' + this.attr.nonPriorityBillContent + ']').last('li').find('[' + this.attr.currencyAmount + ']').each(function () {
      if (!AutoNumeric.isManagedByAutoNumeric(this)) {
        new AutoNumeric(this, {
          currencySymbol: '£',
          minimumValue: 0
        });
      }
    });
  },
  _reIndexNonPriorityBills: function _reIndexNonPriorityBills() {
    var nonPriorityBills = $('[' + this.attr.nonPriorityBillContent + ']').find('li');
    for (var i = 0; i < nonPriorityBills.length; i++) {
      var _index = i;
      $(nonPriorityBills[i]).find('input').each(function () {
        var fieldName = $(this).attr('name');
        var updatedName = fieldName.replace(/\[.*\]/, "[" + _index + "]");
        $(this).attr('name', updatedName);
      });
      $(nonPriorityBills[i]).find('select').each(function () {
        var fieldName = $(this).attr('name');
        var updatedName = fieldName.replace(/\[.*\]/, "[" + _index + "]");
        $(this).attr('name', updatedName);
      });
    }
    this.contants.nonPriorityIndex = 0;
    if (nonPriorityBills.length) {
      this.contants.nonPriorityIndex = nonPriorityBills.length - 1;
    }
  },
  _calculateSavings: function _calculateSavings() {
    var poundFormatting = new Intl.NumberFormat(this.settings.pounds.internationalCode, {
      style: this.settings.pounds.style,
      currency: this.settings.pounds.currencyCode
    });
    var savingsCheckboxChecked = $('[' + this.attr.excludeSavingsCheckbox + ']').is(':checked');
    var incomeSections = $('[' + this.attr.incomeSection + ']').find('[' + this.attr.sectionTotal + ']');
    var expenseSections = $('[' + this.attr.expenditureSection + ']').find('[' + this.attr.sectionTotal + ']');
    var nonPrioritySection = $('[' + this.attr.expenditureSection + ']').find('[' + this.attr.sectionCode + '="NON_PRIORITY_BILLS"]').find('[' + this.attr.sectionTotal + ']');
    var savingsSection = $('[' + this.attr.expenditureSection + ']').find('[' + this.attr.sectionCode + '="SAVINGS"]').find('[' + this.attr.sectionTotal + ']');
    var incomeTotal = 0;
    var expenseTotal = 0;
    var nonPriorityTotal = 0;
    var savingsTotal = 0;
    var savingAmount = 0;
    $(incomeSections).each(function () {
      var decimalValue = Number($(this).text().replace(/[^0-9.-]+/g, ""));
      incomeTotal += decimalValue;
    });
    $(expenseSections).each(function () {
      var decimalValue = Number($(this).text().replace(/[^0-9.-]+/g, ""));
      expenseTotal += decimalValue;
    });
    var nonPriorityTotal = Number($(nonPrioritySection).text().replace(/[^0-9.-]+/g, ""));
    expenseTotal = expenseTotal - nonPriorityTotal;
    var savingsTotal = Number($(savingsSection).text().replace(/[^0-9.-]+/g, ""));
    expenseTotal = expenseTotal - savingsTotal;
    if (incomeTotal > expenseTotal) {
      savingAmount = Math.floor((incomeTotal - expenseTotal) * 100 * 0.1) / 100;
      savingAmount = savingAmount > 25 ? 25 : savingAmount;
    }
    $('[' + this.attr.fieldValue + '="SAVINGS"]').val(savingAmount);
    if (!savingsCheckboxChecked) {
      $('[' + this.attr.sectionCode + '="SAVINGS"]').find('[' + this.attr.sectionTotal + ']').html(poundFormatting.format(savingAmount));
    }
  }
});